export default __webpack_public_path__ + "static/media/TasteMade.af5ff2f8.svg";